export enum PhoneType {    
    Office = 1,
    Mobile = 2,
    Pager = 3,
    Fax = 4,
    Other = 5,
    Emergency = 6
}